export class EventTicketsConstants {
  public static EVENT_TICKETS = 'event-tickets'
  public static TICKET_UUID = ':uuid'
}
